import _ from "lodash";

/**
 *
 * @param {*} min
 * @param {*} max
 * @param {*} diff
 */

export const createLabels = (min, max, diff) => {
  const obj = {};

  for (var i = min; i <= max; i = i + diff) {
    obj[i] = i;
  }

  return obj;
};

export const findPercentageValue = (currentValue, config) => {
  var lowerValues = Object.keys(config).filter(key => key <= currentValue);
  var maxKey = _.max(lowerValues);

  return config[maxKey] || config[Object.keys(config)[0]];
};

export const findPercentageKey = (currentValue, config) => {
  var lowerValues = Object.keys(config).filter(key => key <= currentValue);
  var maxKey = _.max(lowerValues);

  return maxKey || Object.keys(config)[0];
};

export const IsValidUrl = url => {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator

  return !!pattern.test(url);
};

export const canUseDOM = !!(
  typeof window !== "undefined" &&
  window.document &&
  window.document.createElement
);

export const isExternal = url => {
  if (canUseDOM()) {
    var tempLink = document.createElement("a");
    tempLink.href = url;
    return tempLink.hostname === window.location.hostname;
  }

  return false;
};

export const getUTMcookie = () => {
  var utmArray = [];
  var cookieNames = document.cookie.split(";");
  for (var i = 0; i < cookieNames.length; i++) {
    if (
      cookieNames[i].substring(0, 10) == " UTMparams" ||
      cookieNames[i].substring(0, 9) == "UTMparams"
    ) {
      if (cookieNames[i].substring(0, 1) == " ") {
        var utmCookie = cookieNames[i];
        var cleanName = utmCookie.substr(1);
      } else {
        var cleanName = cookieNames[i];
      }
      utmArray = cleanName.substr(10).split("/");
    }
  }
  return utmArray;
};

export const addUtmInputValues = (values, utmArray) => {
  const inputs = {
    ...values,
    utm_medium: utmArray[0],
    utm_source: utmArray[1],
    utm_campaign: utmArray[2],
    utm_content: utmArray[3],
    utm_term: utmArray[4],
  };

  return inputs;
};

export const addUtmToUrl = (url, utmArray) => {
  const utmObject = {
    utm_medium: utmArray[0],
    utm_source: utmArray[1],
    utm_campaign: utmArray[2],
    utm_content: utmArray[3],
    utm_term: utmArray[4],
  };

  const encodedURI = Object.entries(utmObject)
    .map(([key, val]) => `${key}=${val}`)
    .join("&");

  return `${url}?${encodedURI}`;
};

export const updateActiveCampaignForm = form => {
  return form.replace(
    `if (no_error && elem.name == 'email') {`,
    `if (no_error && elem.name == 'email') {
        if (
          value.indexOf("@gmail") > -1 ||
          value.indexOf("@yahoo") > -1 ||
          value.indexOf("@hotmail") > -1
       ) {
        elem.className = elem.className + ' _has_error';
        no_error = false;
        tooltip = create_tooltip(elem, "Enter a work email address.");
      }
    } if (no_error && elem.name == 'email') {`
  );
};

export const setInputs = () => {
  const utmArray = getUTMcookie();

  try {
    document
      .querySelectorAll('input[name="field[24]"')[0]
      .setAttribute("value", utmArray[0]); // utm_medium
    document
      .querySelectorAll('input[name="field[25]"')[0]
      .setAttribute("value", utmArray[1]); // utm_source
    document
      .querySelectorAll('input[name="field[26]"')[0]
      .setAttribute("value", utmArray[2]); // utm_campaign
    document
      .querySelectorAll('input[name="field[27]"')[0]
      .setAttribute("value", utmArray[3]); // utm_content
    document
      .querySelectorAll('input[name="field[28]"')[0]
      .setAttribute("value", utmArray[4]);
  } catch (e) {}
  // utm_term
};

export const openLinks = () => {
  var links = document.querySelectorAll("a");

  for (var i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname != window.location.hostname) {
      links[i].target = "_blank";
    }
  }
};
